<template>
  <DashboardPage>
    <PageBreadcrumb
      :crumbs="[{
        label: $t('selection_site.selection_sites')
      }]"
    />

    <SpinningLoader :pending="pending">
      <div class="sm:container mx-2 sm:mx-auto">
        <AsteonlineCard
          v-for="selectionSite in selectionSites"
          :key="'selection-site-' + selectionSite.uuid"
        >
          <CardHead>
            <WalletIcon class="h-4 w-4 mr-2 inline-block" />
            {{ selectionSite.displayName }}
          </CardHead>

          <CardBody v-if="selectionSite.companyName || selectionSite.address || selectionSite.phone || selectionSite.fax">
            <p v-if="selectionSite.companyName">
              {{ selectionSite.companyName }}
            </p>
            <p v-if="selectionSite.address">
              {{ selectionSite.address }}
            </p>
            <p v-if="selectionSite.phone">
              {{ $t('selection_site.phone') }}: {{ selectionSite.phone }}
            </p>
            <p v-if="selectionSite.fax">
              {{ $t('selection_site.fax') }}: {{ selectionSite.fax }}
            </p>
          </CardBody>
        </AsteonlineCard>
      </div>
    </SpinningLoader>
  </DashboardPage>
</template>

<script setup>
import { WalletIcon } from '@heroicons/vue/24/solid';
import { ref } from 'vue'

import AsteonlineCard from '@/components/card/AsteonlineCard.vue';
import CardBody from '@/components/card/CardBody.vue';
import CardHead from '@/components/card/CardHead.vue';
import DashboardPage from '@/components/DashboardPage.vue';
import PageBreadcrumb from '@/components/PageBreadcrumb.vue';
import SpinningLoader from '@/components/SpinningLoader.vue';
import useAxios from '@/composables/axios';

const axios = useAxios()

let pending = ref(true)
let selectionSites = ref([])

axios.get('/selection-site/list').then((resp) => {
    selectionSites.value = resp.data
    pending.value = false;
}).catch(() => {
});

</script>